import { useCallback, useState } from 'react';
import { Link } from 'react-router-dom';
import { ClipboardList } from 'lucide-react';
import { Button, Card, EmptyState } from '@elbklar/ui';
import type { DashboardData } from '@/lib/api';
import { TaskCard } from '@/features/tasks/components/TaskCard';
import { AufgabeBearbeiten } from '@/features/tasks/components/AufgabeBearbeiten';
import { useAufgabeErledigen } from '@/features/tasks/useAufgabeErledigen';

/**
 * Am Handy das Erste auf der Übersicht: überfällige und heute fällige
 * Aufgaben, zum Erledigen mit dem Daumen (TaskCard, 44 px Trefferfläche)
 * und mit dem Stift zum Bearbeiten.
 *
 * Nicht die ganze Zeile als Klickfläche: Sie ist `checkable`, und `ListRow`
 * schliesst `onClick` damit aus — die runde Checkbox wäre ein Klickziel im
 * Klickziel. Eine Aufgabe hakt man ab, einen Eintrag öffnet man.
 */
export function HeuteFaellig({ tasks }: { tasks: DashboardData['tasks'] }) {
  const faellig = [...tasks.overdue, ...tasks.today];
  const erledigen = useAufgabeErledigen();
  const [bearbeiteteAufgabe, setBearbeiteteAufgabe] = useState<string | null>(null);
  const schliessen = useCallback(() => setBearbeiteteAufgabe(null), []);

  return (
    <Card
      title="Heute fällig"
      flush
      actions={
        <Button asChild size="sm" variant="ghost">
          <Link to="/tasks">Alle Aufgaben</Link>
        </Button>
      }
    >
      {faellig.length > 0 ? (
        faellig.map((task) => (
          <TaskCard key={task.id} task={task} onStatusChange={erledigen} onEdit={(a) => setBearbeiteteAufgabe(a.id)} />
        ))
      ) : (
        <EmptyState icon={ClipboardList} title="Nichts fällig" description="Überfällige und heute fällige Aufgaben erscheinen hier." className="py-6" />
      )}

      <AufgabeBearbeiten aufgabeId={bearbeiteteAufgabe} onClose={schliessen} />
    </Card>
  );
}
